import './index.scss'

const AnimatedLetters = ({ letterClass, strArray, idx, showCursor }) => {
  return (
    <span>
      {strArray.map((char, i) => (
        <span key={char + i} className={`${letterClass} _${i + idx}`}>
          {char}
        </span>
      ))}
      {showCursor && (
        <span
          className="terminal-cursor"
          style={{ animationDelay: `${(strArray.length + idx) / 15 + 0.8}s, ${(strArray.length + idx) / 15 + 0.8}s` }}
        />
      )}
    </span>
  )
}

export default AnimatedLetters